const service = require('@/assets/js/request')
class phoneLogin {
  /**
   * 获取验证码
   */
  static getPhoneCode (target, phone, type) {
    service.request({
      method: 'POST',
      url: 'getPhoneCode',
      params: {
        phone, type
      }
    }).then(res => {
      if (res.code === 2001) {
        console.log(res)
      }
    }).catch(err => {
      service.error(err, {
        that: target
      })
    })
  }
  /**
   * 密码重置
   */
  static phoneReset (target, phone, code, password) {
    service.request({
      method: 'POST',
      url: 'ResetPossword',
      params: {
        phone, code, password
      }
    }).then(res => {
      if (res.code === 2001) {
        // target.$store.dispatch('set_isLogin', false)
        // console.log(res)
        target.$message({
          message: res.msg,
          type: 'success'
        })
        setTimeout(() => {
          target.back()
        }, 1000)
      } else {
        target.$message({
          message: res.msg,
          type: 'warning'
        })
      }
    }).catch(err => {
      service.error(err, {
        that: target
      })
    })
  }
}

export default phoneLogin



// WEBPACK FOOTER //
// ./src/components/login/reset/reset.js